import React from 'react';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';
import PropTypes from 'prop-types';

const DefaultExpandedChildComponent = ({
  collection,
  onSubmit,
  onSubmitBefore,
  onChange,
}) => {
  return (
    <MetaCollectionFormDialog
      collection={collection}
      FormProps={{
        onChange,
        onSubmit,
        onSubmitBefore,
      }}
    />
  );
};

DefaultExpandedChildComponent.defaultProps = {
  onSubmit: null,
  onSubmitBefore: null,
  onChange: null,
};

DefaultExpandedChildComponent.propTypes = {
  collection: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onSubmitBefore: PropTypes.func,
};

export default DefaultExpandedChildComponent;
